import type { NotesView } from '../types/notes'

// The Pages line on the Notes page. OneNote allows an app 400 requests an hour for one person, so a large notebook is
// read newest first over several hourly reads (prod, 2026-10-04: 1,069 pages in 218 sections). A bare "150 on file"
// would look finished; the line says how far the read has got and what is still coming.

export interface PagesLine {
  /** What is on file, against what OneNote holds when the two differ. */
  text: string
  /** What is still coming, or null when the read is complete. */
  pending: string | null
}

const n = (x: number) => x.toLocaleString('en-US')

export function pagesLine(v: Pick<NotesView, 'pages' | 'pagesFound' | 'pagesToRead' | 'sectionsToList'>): PagesLine {
  const toRead = Math.max(0, v.pagesToRead)
  const toList = Math.max(0, v.sectionsToList)
  if (toRead === 0 && toList === 0) return { text: `${n(v.pages)} on file`, pending: null }
  // the total is only a floor while sections are still to be looked through
  const text = v.pagesFound > v.pages
    ? `${n(v.pages)} of ${toList > 0 ? 'at least ' : ''}${n(v.pagesFound)} on file`
    : `${n(v.pages)} on file`
  const parts: string[] = []
  if (toRead > 0) parts.push(`${n(toRead)} ${toRead === 1 ? 'page is' : 'pages are'} still to read`)
  if (toList > 0) parts.push(`${n(toList)} ${toList === 1 ? 'section is' : 'sections are'} still to look through`)
  return { text, pending: `${parts.join(' and ')}. OneNote allows 400 requests an hour, so the rest is read newest first on the next hourly reads.` }
}
